/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class NextGenReportResponse {
    getFixupPrototypeFunction() { return NextGenReportResponse.fixupPrototype; }

    static newInstance(model: Partial<NextGenReportResponse>): NextGenReportResponse {
        let obj = Object.assign(new NextGenReportResponse(), model);
        NextGenReportResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<NextGenReportResponse>): NextGenReportResponse {
        if (!model) return null;
        return NextGenReportResponse.newInstance(<NextGenReportResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: NextGenReportResponse) {
        if (!obj) return;

        models.NextGenReportResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: NextGenReportResponse): boolean {
        Object.setPrototypeOf(obj, NextGenReportResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.attachments) {
            for (let val of this.attachments) {
                models.AttachmentStorageBase.fixupPrototype(val);
            }
        }
    }

    /**
     * Unique ID for the report.
     */
    sys_id: string;

    /**
     * ID of the background job responsible for generating the report.
     */
    background_job_id: string;

    /**
     * List of attachment storage types. Can be CoreStack Attachment or Azure Blob Storage.
     */
    attachments: Array<models.AttachmentStorageBase>;

    /**
     * Status of the report
     */
    status: models.ReportStatus;

}
